import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BackButton = ({ fallback = "/home", label = "Back", className = "" }) => {
  const navigate = useNavigate();
  const go = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button
      type="button"
      data-testid="back-button"
      onClick={go}
      className={`inline-flex items-center gap-2 text-sm text-slate-400 hover:text-slate-100 transition-colors duration-300 ${className}`}
    >
      <ArrowLeft className="w-4 h-4" /> {label}
    </button>
  );
};
